import { withAuthContext } from 'auth/AuthContext';
import classNames from 'classnames';
import RequiresActionNotificationsModalContent from 'components/clinical-data/RequiresActionNotificationsModalContent';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import { UnregisterCallback } from 'history';
import * as React from 'react';
import { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouteComponentProps, withRouter } from 'react-router';
import { UserNotificationConsumerRenderProps, withUserNotificationContext } from 'routes/UserNotificationsContext';
import { Button, Icon, Menu, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const NotificationsModal = styled(Modal)`

  &.ui.modal {
    overflow: hidden;
    display: flex !important;
    flex-direction: column;
    width: calc(100% - 2rem);
    height: calc(100% - 4rem);

    .content {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }

  .close-button {
    float: right;
    cursor: pointer;
    margin-top: 0.375rem;
  }

  .actions-row {
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    margin-top: 1rem;
  }
`

interface Props extends MessageSourceProps,
    RouteComponentProps,
    UserNotificationConsumerRenderProps {
}

interface State {
  requiredDoctorActionsModalOpen: boolean,
  requiredDoctorActionsKey: number
}

class UserNotificationsMenuItem extends Component<Props, State> {

  state = {
    requiredDoctorActionsModalOpen: false,
    requiredDoctorActionsKey: 1
  };

  private readonly locationListenerUnregisterCallback: UnregisterCallback;


  constructor(props: Props, context: any) {
    super(props, context);

    const history = this.props.history;
    const initLocation = history.location;
    this.locationListenerUnregisterCallback = props.history.listen(location => {
      if (location !== initLocation) {
        this.setState({
          requiredDoctorActionsModalOpen: false
        });
      }
    });

  }

  componentWillUnmount() {
    this.locationListenerUnregisterCallback && this.locationListenerUnregisterCallback();
  }

  openRequiredDoctorActionsModal = () => {
    this.setState({requiredDoctorActionsModalOpen: true});
  }

  closeRequiredDoctorActionsModal = () => {
    this.setState({requiredDoctorActionsModalOpen: false});
  }

  render(): React.ReactNode {

    const {getMessage} = this.props;

    const {
      requiredDoctorActionsModalOpen,
      requiredDoctorActionsKey
    } = this.state;

    const notificationDocuments = this.props.documents || [];
    const activeNotificationDocuments = notificationDocuments.filter(
        doc => doc.requiresDoctorAction)

    const totalActiveNotificationDocs = activeNotificationDocuments.length;
    if (!this.props.canReceiveDoctorNotifications()) {
      return <></>;
    }

    const hasActiveNotifications = totalActiveNotificationDocs > 0;

    const totalDocsThatRequireAction = this.props.totalNumberOfDocumentsThatRequireDoctorAction;

    return <>
      <Menu.Item
          className="notification-menu-item"
          onClick={this.openRequiredDoctorActionsModal}
      >
        <div className={classNames([
          "notification-div",
          {"active": hasActiveNotifications}
        ])}
        >
          {
            hasActiveNotifications
                ? `${totalActiveNotificationDocs} / ${totalDocsThatRequireAction}`
                : `${totalDocsThatRequireAction}`
          }
        </div>
      </Menu.Item>

      <NotificationsModal
          open={requiredDoctorActionsModalOpen}
          onClose={() => {
            this.setState({
              requiredDoctorActionsModalOpen: false
            })
          }}
          closeOnDimmerClick={false}
      >
        <Modal.Header>
          {getMessage("notifications.title")}
          <Icon name={"close"}
                className={"close-button"}
                size={"small"}
                onClick={() => {
                  this.closeRequiredDoctorActionsModal()
                }}
          />
        </Modal.Header>
        <FormModalContentContainer>
          <RequiresActionNotificationsModalContent key={requiredDoctorActionsKey}/>
          <div className={"actions-row"}>
            <Button compact
                    primary
                    onClick={() => {
                      this.setState({
                        requiredDoctorActionsKey: requiredDoctorActionsKey + 1
                      });
                    }}
            >
              {getMessage("button.refresh")}
            </Button>

            <Button compact
                    basic
                    onClick={this.closeRequiredDoctorActionsModal}
            >
              {getMessage("button.close")}
            </Button>
          </div>
        </FormModalContentContainer>
      </NotificationsModal>
    </>;
  }

}

export default withRouterWorkaround(
    withUserNotificationContext(
        withRouter(
            withAuthContext(
                withMessages(
                    UserNotificationsMenuItem
                )))));
